var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.831+167.43C125.536+167.43+96.9443+198.599+96.9443+237.112L96.9443+794.766C96.9443+833.279+125.536+864.481+160.831+864.481L448.215+864.481C448.247+864.481+448.273+864.481+448.305+864.481C448.337+864.481+448.363+864.481+448.395+864.481L863.552+864.481C898.847+864.481+927.439+833.279+927.439+794.766L927.439+237.112C927.439+198.599+898.847+167.43+863.552+167.43L160.831+167.43Z",
    opacity: 1,
    fill: "#90e4f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68d9e7",
    opacity: 1,
    d: "M192.786+237.112L320.559+237.112C338.19+237.112+352.487+252.747+352.487+271.986L352.487+411.383C352.487+430.622+338.19+446.257+320.559+446.257L192.786+446.257C175.154+446.257+160.827+430.622+160.827+411.383L160.827+271.986C160.827+252.747+175.154+237.112+192.786+237.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68d9e7",
    d: "M448.305+237.112L576.078+237.112C593.71+237.112+608.006+252.747+608.006+271.986L608.006+411.383C608.006+430.622+593.71+446.257+576.078+446.257L575.539+446.257C575.476+446.257+575.454+446.257+575.39+446.257L448.305+446.257C430.673+446.257+416.377+430.622+416.377+411.383L416.377+271.986C416.377+252.747+430.673+237.112+448.305+237.112Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.851+237.112L831.594+237.112C849.226+237.112+863.552+252.747+863.552+271.986L863.552+411.383C863.552+430.622+849.226+446.257+831.594+446.257L703.851+446.257C686.219+446.257+671.893+430.622+671.893+411.383L671.893+271.986C671.893+252.747+686.219+237.112+703.851+237.112Z",
    opacity: 1,
    fill: "#68d9e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59+510.447L414.547+510.447C442.553+510.447+465.262+530.631+465.262+555.519L465.262+735.892C465.262+760.78+442.553+780.963+414.547+780.963L211.59+780.963C183.584+780.963+160.827+760.78+160.827+735.892L160.827+555.519C160.827+530.631+183.584+510.447+211.59+510.447Z",
    fill: "#68d9e7",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68d9e7",
    opacity: 1,
    d: "M580.549+510.447L806.793+510.447C838.013+510.447+863.327+530.631+863.327+555.519L863.327+735.892C863.327+760.78+838.013+780.963+806.793+780.963L580.549+780.963C549.33+780.963+523.962+760.78+523.962+735.892L523.962+555.519C523.962+530.631+549.33+510.447+580.549+510.447Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/Meal.cfe40caf9c820957028e4c782a97af48.svg";
export { ForwardRef as ReactComponent };